
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deals/[bundleCode]",
      function () {
        return require("private-next-pages/deals/[bundleCode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deals/[bundleCode]"])
      });
    }
  